import {
  SaveSuccessResponse,
  TolNotification,
  TolNotificationsInfoResponse,
  TolOtacMaintenance,
} from '../../types/tolOperations'

export interface TolOperationsApiError extends Error {
  response?: {
    status: number
    data?: unknown
  }
  isNetworkError?: boolean
}

/**
 * IP制限など強制ログアウト対象のエラーか判定する。
 * 401は対象外: トークン期限切れはエラーモーダルからのリロードでサイレント再認証により復帰できるため
 */
export const isTolOperationsNetworkError = (error: unknown): boolean => {
  const apiError = error as TolOperationsApiError | undefined
  return apiError?.isNetworkError === true
}

const createTolOperationsApiError = async (response: Response): Promise<TolOperationsApiError> => {
  const error: TolOperationsApiError = new Error('ToL Operations API Error')
  let data: unknown

  const contentType = response.headers.get('content-type')
  if (contentType && contentType.includes('application/json')) {
    data = await response.json()
  }

  error.response = {
    status: response.status,
    data,
  }

  return error
}

const tolOperationsFetch = async <T>(path: string, accessToken: string, options: RequestInit = {}): Promise<T> => {
  const apiUrl = `${process.env.REACT_APP_MANAGEMENT_API_ENDPOINT}${path}`
  const headers: Record<string, string> = {
    authorization: accessToken,
    ...(options.headers as Record<string, string>),
  }

  if (options.body) {
    headers['Content-Type'] = 'application/json'
  }

  let response: Response
  try {
    response = await fetch(apiUrl, {
      ...options,
      headers,
    })
  } catch {
    // IP制限、オフライン等でレスポンスが得られない場合の処理
    const error: TolOperationsApiError = new Error('ToL Operations API Network Error')
    error.isNetworkError = true
    throw error
  }

  if (!response.ok) {
    throw await createTolOperationsApiError(response)
  }

  return response.json()
}

export const tolNotificationApi = {
  getList: async (accessToken: string): Promise<TolNotificationsInfoResponse> => {
    return tolOperationsFetch<TolNotificationsInfoResponse>('/tol/notifications/info', accessToken, {
      method: 'GET',
    })
  },

  save: async (accessToken: string, data: { information: TolNotification[] }): Promise<SaveSuccessResponse> => {
    return tolOperationsFetch<SaveSuccessResponse>('/tol/notifications/save', accessToken, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },
}

export const tolOtacMaintenanceApi = {
  getList: async (accessToken: string): Promise<TolOtacMaintenance[]> => {
    return tolOperationsFetch<TolOtacMaintenance[]>('/tol/otac-maintenance/info', accessToken, {
      method: 'GET',
    })
  },

  save: async (accessToken: string, data: TolOtacMaintenance[]): Promise<SaveSuccessResponse> => {
    return tolOperationsFetch<SaveSuccessResponse>('/tol/otac-maintenance/save', accessToken, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },
}
